import Controls from '../Controls';
import PlayheadPosition from 'components/Tooltip/PlayheadPosition';
import usePlayerActions from 'components/Player/PlayerActions/usePlayerActions';
import usePlayerState from 'contexts/PlayerState/usePlayerState';
import useTranslate from 'contexts/TranslateContext/useTranslate';
import { useSelector } from 'react-redux';
import type { State } from 'state/types';

function PodcastOverflow() {
  const actions = usePlayerActions();
  const state = usePlayerState();
  const translate = useTranslate();

  const followed = useSelector<State, boolean>(s =>
    state?.stationId ? s.podcast.shows[state.stationId].followed : false
  );

  return (
    <Controls.Overflow>
      <Controls.Overflow.Link
        aria-label="Episode Info Link"
        disabled={!state?.episodeUrl}
        to={state?.episodeUrl}
      >
        {translate('Episode Info')}
      </Controls.Overflow.Link>
      <Controls.Overflow.Button
        aria-label="Share Button"
        data-test="share-button"
        disabled={!state?.episodeUrl}
        onClick={() => {
          actions.share();
        }}
      >
        {translate('Share Episode')}
      </Controls.Overflow.Button>
      <Controls.Overflow.Button
        aria-label="Share From Timestamp Button"
        data-test="share-timestamp-button"
        disabled={!state?.episodeUrl}
        onClick={() => {
          actions.share(true);
        }}
      >
        {translate('Share from')} <PlayheadPosition />
      </Controls.Overflow.Button>
      <Controls.Overflow.Link
        aria-label="Follow Button"
        data-test="follow-button"
        onClick={actions.toggleFollowed}
      >
        {followed ? translate('Unfollow Podcast') : translate('Follow Podcast')}
      </Controls.Overflow.Link>
    </Controls.Overflow>
  );
}

export default PodcastOverflow;
